import React from 'react';

export interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export function LoadingSpinner({ message = 'Loading...', className = '' }: LoadingSpinnerProps) {
  return (
    <div className={`repos-loading ${className}`}>
      <i className="fa-solid fa-spinner fa-spin loading-icon"></i>
      <p>{message}</p>
    </div>
  );
}
